import React, {useContext, useEffect, useState} from "react";
import {Link, NavLink, useLocation, useNavigate} from "react-router-dom";
import {Col, Container, Image, Row, Button} from "react-bootstrap";
import axios from "axios";
import {useSanctum} from "react-sanctum";
import {useAppUniqueToken} from "../../hooks/useAppUniqueToken";

import LoadingSpinner from "../toolkit/LoadingSpinner";
import {useStockStorage} from "../../hooks/useStockStorage";

import JSONSystemRoles from '../../../../json/system/system_roles.json'

import {useTranslation} from "react-i18next";
import {useToolkit} from "../../hooks/useToolkit";


interface IProps {
    showSection: string,
    customToken: string,
    customTokenStatus: string
}

const messages = {
    ValueMessage1: ["Importo totale", <br/>, "richieste inserite finora: "],
    ValueMessage2: ["Importo totale richieste", <br/>, "di iscrizione: "],
};

const UserInfo = ({ showSection, customToken, customTokenStatus, ...props }: IProps) => {
    const {getCurrentQuote, removeCurrentQuote} = useToolkit();
    const { t } = useTranslation();

    //const{getAppUniqueToken} = useAppUniqueToken();
    //const [uaToken,setUaToken] = useState('');
    //const {getStockLocalStorageToken} = useStockLocalStorage();

    //const location = useLocation();

    const [isLoading, setLoading] = useState(true);
    let navigate = useNavigate();
    const { user, checkAuthentication } = useSanctum();
    const { removeAppUniqueToken } = useAppUniqueToken();
    const [data, setData] = useState<any>([])

    const [subNumber, setSubNumber] = useState(0)
    const [subMessage, setSubMessage] = useState('')

    const [subValue, setSubValue] = useState(0)
    const [subValueMessage, setSubValueMessage] = useState<any>('')

    const [userSystemRole, setUserSystemRole] = useState('');


    useEffect(() => {
        setLoading(true);

 /*       if(location.pathname !== '/')
            setUaToken(getStockLocalStorageToken());
        else
            setUaToken(getAppUniqueToken());
*/

        getUserInfo()
            .then(() => {
                //checkAuthentication();
                setLoading(false);


            });
    }, []);

 /*   useEffect(() => {
        setLoading(true);
        getUserInfo()
            .then(() => {
                //checkAuthentication();
                setLoading(false);
            });
    }, [uaToken]);
*/
    //console.log('currentQuote1: ' + getCurrentQuote());

/*
    useEffect(() => {

        alert(getCurrentQuote());
        //alert(getCurrentQuote());
        //console.log('getCurrentQuote(): ' + getCurrentQuote());
        console.log('userInfo - useEffect - currentQuote: ' + getCurrentQuote());

        //alert(getCurrentQuote());

        //let currentQuota = parseInt(cQuote);
        //let ncq = subValue + currentQuote;
        //setCurrentQuote(getCurrentQuote());
        //setSubValue(ncq);

        //setCurrentQuote(getCurrentQuote());

        if(cQuote !== getCurrentQuote())
        {
            alert(getCurrentQuote());

            let currentQuota = parseInt(cQuote);
            let ncq = subValue + currentQuota;
            setSubValue(ncq);

            setCurrentQuote(getCurrentQuote());
        }
    }, [() => getCurrentQuote('userInfo')]);
*/

    useEffect(() => {
        if(user && user.user.system_role)
        {
            const p = JSONSystemRoles.system_roles.find(x => x.key === user.user.system_role);
            if(p)
            {
                var r = p?.description;
                setUserSystemRole(r);
            }
            else
                setUserSystemRole(user.user.system_role);
        }
    }, [user]);

    const getUserInfo = async () => {
        if(customToken && customToken !== '')
        {
            //alert('getUserInfo: ' + customToken + ' ' + customTokenStatus);

            const payload = {
                uaToken: customToken,
                status: customTokenStatus
            };

            let currentUserInfo = await axios.post('api/userinfo', payload)
                .then(response => {

                    //console.log('api/userinfo');
                    //console.log(response.data);

                    setData(response.data);

                    let n:number = location.pathname === '/' ? 1 : 0
                    setSubNumber(response.data.info.subscriptions_count + n);

                    let m:string = location.pathname === '/'
                        ? 'Stai inserendo la richiesta n: '
                        : 'Numero delle richieste inserite: '
                    setSubMessage(m);

                    setSubValue(response.data.info.stock_value);

                    setSubValueMessage(location.pathname !== '/'
                        ? messages.ValueMessage1
                        : messages.ValueMessage2);
                });
        }
    };

    const handleLogout = () => {
        removeCurrentQuote();
        removeAppUniqueToken();
    };
    const handleGoToLounge = () => {
        navigate('/lounge');
    };


    return (
        <div className={showSection}>
            <div className="info-utente">
                Utente: <b>{!isLoading && (user && (user.user.name))} {!isLoading && (user && (user.user.surname))}</b><br />
                {!isLoading && (user && (userSystemRole))}
            </div>
            <div className="info-tessere">
                {!isLoading && (subMessage)} <b>{!isLoading && (subNumber)}</b>
            </div>

            <div className="info-importo">
                {!isLoading && (subValueMessage)} <b>{!isLoading && subValue}</b>
            </div>
            {
                location.pathname === '/' && (
                    <div className="info-importo">
                        {
                            !isLoading &&
                            (
                                <>
                                    <Button key="lounge" id="Lounge" className="btn_1 green mt-2" onClick={handleGoToLounge}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                             className="bi bi-person-badge-fill" viewBox="0 0 16 16">
                                            <path
                                                d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm4.5 0a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zM8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm5 2.755C12.146 12.825 10.623 12 8 12s-4.146.826-5 1.755V14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-.245z"/>
                                        </svg>&nbsp;{t('captions.lounge')}
                                    </Button>
                                    <br key="br-after-lounge" />
                                </>
                            )
                        }

                        <Button key="logout" id="Logout" className="btn_1 green mt-2" onClick={handleLogout}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                 fill="currentColor" className="bi bi-door-open-fill"
                                 viewBox="0 0 16 16">
                                <path
                                    d="M1.5 15a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1H13V2.5A1.5 1.5 0 0 0 11.5 1H11V.5a.5.5 0 0 0-.57-.495l-7 1A.5.5 0 0 0 3 1.5V15H1.5zM11 2h.5a.5.5 0 0 1 .5.5V15h-1V2zm-2.5 8c-.276 0-.5-.448-.5-1s.224-1 .5-1 .5.448.5 1-.224 1-.5 1z"/>
                            </svg>&nbsp;{t('captions.logOut')}
                        </Button>
                    </div>
                )
            }
        </div>
    );
};

export default UserInfo;
